const KEY = "torri_consent";
export const OPEN_EVENT = "torri:open-cookie-prefs";

export function getConsent() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "null");
  } catch (e) {
    return null;
  }
}

export function saveConsent(analytics) {
  const c = { analytics: !!analytics, date: new Date().toISOString(), v: 1 };
  try { localStorage.setItem(KEY, JSON.stringify(c)); } catch (e) { /* noop */ }
  if (typeof window.gtag === "function") {
    window.gtag("consent", "update", { analytics_storage: c.analytics ? "granted" : "denied" });
  }
  return c;
}

export const openCookiePrefs = () => window.dispatchEvent(new Event(OPEN_EVENT));
